import { Button, Grid, Typography } from '@material-ui/core'
import React from 'react'
import BillCard, {
  BillState
} from '../../component/Config/Subscription/BillCard'
import CreditCard from '../../component/Config/Subscription/CreditCard'
import PlanCard from '../../component/Config/Subscription/PlanCard'
import { useSubscriptionStyles } from '../../component/Config/Subscription/styles'
import SubscriptionLayout from '../../component/Config/Subscription/SubscriptionLayout'

export const Plans = (): JSX.Element => {
  const classes = useSubscriptionStyles()

  const history = {
    date: '03 Novembro 2020',
    plan: 'Plano Avançado',
    value: 1000,
    state: BillState.Sale
  }

  return (
    <SubscriptionLayout>
      <Grid
        container
        justify="space-between"
        spacing={5}
        style={{
          marginBottom: 15
        }}
      >
        <Grid item xs={12} lg={6}>
          <h1 className={classes.title}>Plano de Assinatura</h1>
          <PlanCard />
        </Grid>
        <Grid item xs={12} lg={6}>
          <h1 className={classes.title}>Forma de Pagamento</h1>
          <CreditCard />
        </Grid>
      </Grid>
      <br />
      <Grid container>
        <Grid item>
          <Typography variant="h6" style={{ marginRight: 15 }}>
            2 Acessos
          </Typography>
        </Grid>
        <Grid item>
          <Button color="primary" variant="contained">
            Atualizar número de acessos
          </Button>
        </Grid>
      </Grid>
      <br />
      <Grid container style={{ marginTop: 25 }}>
        <Grid item>
          <Typography
            className={classes.title}
            variant="body1"
            style={{ marginRight: 15 }}
          >
            Fatura
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.overflow}>
          <Typography variant="caption">Última fatura</Typography>
          <BillCard
            bill={{
              date: '03 Novembro 2020',
              plan: 'Plano Avançado',
              value: 1000,
              state: BillState.Sale
            }}
          />
          <Typography variant="caption">Histórico</Typography>
          <BillCard bill={{ ...history, state: BillState.Sale }} />
          <BillCard bill={{ ...history }} />
          <BillCard bill={{ ...history }} />
          <BillCard bill={{ ...history }} />
        </Grid>
      </Grid>
    </SubscriptionLayout>
  )
}
